/**
 * @todo Item Configuration resource
 *
 * @name ItemConfiguration
 * @class
 * @augments TmrResource
 */
export const factory = [
  'ItemConfiguration',
  /*@ngInject*/ TmrResource => {
    return TmrResource('ItemConfiguration', null, null, () => ({
      identifiers: [],
    }))
  },
]
